import faqservice from '../img/faqservice.png'
import quickservice from '../img/quickservice.png'
import Btn from './Btn'
export default function QuickServices() {
    return <>
        <div className="quickServices">
            <div className="container" >
                <div className="row" >
                    <div className="col-lg-6 mt-4 mt-lg-0" >
                        <div className="quickBox faq" >
                            <div className="qim" >
                                <img src={faqservice} />
                            </div>
                            <div className="qimCon" >
                                <h2>Frequently Asked <br></br> Questions!</h2>
                                <p>Have questions? Our robust FAQ has you covered.</p>
                                <Btn class="mt-2 btn-blue"
                                    arrow={true}
                                    href="#"
                                >Read FAQ's</Btn>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 mt-4 mt-lg-0" >
                        <div className="quickBox service" >
                            <div className="qim" >
                                <img src={quickservice} />
                            </div>
                            <div className="qimCon" >
                                <h2>Ready to Book <br></br> Our Service?</h2>
                                <p>Reclaim your space with the help of Exquisite Moves!</p>
                                <Btn class="mt-2"
                                    arrow={true}
                                    href="#" >Book our Services now</Btn>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}